export const GET_FILESUMMARIES_ATTEMPT = 'GET_FILESUMMARIES_ATTEMPT';
export const GET_FILESUMMARIES_SUCCESS = 'GET_FILESUMMARIES_SUCCESS';
export const GET_FILESUMMARIES_FAILURE = 'GET_FILESUMMARIES_FAILURE';
export const SET_FILEPROCESS_SUCCESS = 'SET_FILEPROCESS_SUCCESS';
export const SET_FILEPROCESS_FAILURE = 'SET_FILEPROCESS_FAILURE';
export const SET_FILEUPLOAD_ATTEMPT = 'SET_FILEUPLOAD_ATTEMPT';
export const SET_FILEUPLOAD_SUCCESS = 'SET_FILEUPLOAD_SUCCESS';
export const SET_FILEUPLOAD_FAILURE = 'SET_FILEUPLOAD_FAILURE';
export const SORT_FILESUMMARIES = 'SORT_FILESUMMARIES';
export const CLEAR_FILE_LIST = 'CLEAR_FILE_LIST';
export const ACKNOWLEDGE_FILEPROCESS = 'ACKNOWLEDGE_FILEPROCESS';
export const RUN_TYPE_SUBSCRIPTION_UPDATE = 'upd-sub';
export const RUN_TYPE_REFURBISH = 'refurbish';
export const RUN_TYPE_TOKEN_DELETE = 'tok-del';
export const RUN_TYPE_CAMERA_SETTING = 'camera-setting';

// Mirrors the backend allowlist (admin_services bulkUpdates/bulkUpdateTypes/cameraSetting.js),
// which is authoritative and rejects anything else.
const DETECT_LEVELS = ['OFF', 'LOW', 'MEDL', 'MED', 'MEDH', 'HIGH'].map(v => ({ value: v, label: v }));
const ON_OFF = [{ value: true, label: 'Enabled' }, { value: false, label: 'Disabled' }];
export const CAMERA_SETTINGS = [
  { name: 'soundDetect', label: 'Sound detection sensitivity', values: DETECT_LEVELS },
  { name: 'soundDetectEnable', label: 'Sound detection', values: ON_OFF },
  { name: 'imageMotion', label: 'Motion detection sensitivity', values: DETECT_LEVELS },
  { name: 'imageMotionEnable', label: 'Motion detection', values: ON_OFF },
];

